
import React from "react";
import { C, ROLES, RC, RF } from "../utils/api";

export default function Nav({user, logout, cfg, menu, setMenu, setSettings, view, setView, averias, addMode, setAddMode, proyecto, setShowProyectos}) {
  return (
    <div style={{background:C.primary,height:56,display:"flex",alignItems:"center",padding:"0 1rem",zIndex:50,flexShrink:0}}>
      <div style={{display:"flex",alignItems:"center",gap:8,flex:1}}>
        <img src="/logo192.png" style={{height:30}} alt="logo"/>
        <div>
          <p style={{color:C.white,margin:0,fontSize:14,fontWeight:600}}>{cfg.nombre_empresa||"Time Telco"}</p>
          <div style={{display:"flex",alignItems:"center",gap:6}}>
            <p style={{color:"#90CAF9",margin:0,fontSize:11}}>FTTH - {ROLES[user.rol]}</p>
            <span onClick={()=>setShowProyectos(true)} style={{background:"rgba(255,255,255,0.2)",color:"#fff",fontSize:10,padding:"1px 6px",borderRadius:8,cursor:"pointer"}}>{proyecto?proyecto.nombre:"Todas"} ▾</span>
          </div>
        </div>
      </div>
      {view==="mapa" && RF.includes(user.rol) && (
        <select value={addMode||""} onChange={e=>setAddMode(e.target.value||null)} style={{marginRight:8,padding:"4px 8px",borderRadius:6,border:"none",fontSize:12,background:addMode?"#F59E0B":"#1E7BBF",color:"#ffffff"}}>
          <option value="">+ Agregar</option>
          <option value="olt">OLT</option>
          <option value="mufa">Mufa</option>
          <option value="nap">Caja NAP</option>
          <option value="fibra">Fibra</option>
        </select>
      )}
      <div style={{position:"relative"}}>
        <button onClick={()=>setMenu(!menu)} style={{background:"rgba(255,255,255,0.15)",border:"none",borderRadius:8,padding:"6px 10px",color:C.white,cursor:"pointer",fontSize:13,position:"relative"}}>
          Menu
          {averias.length>0 && <span style={{position:"absolute",top:-4,right:-4,background:"#EF4444",color:"#fff",borderRadius:99,fontSize:10,padding:"1px 5px"}}>{averias.length}</span>}
        </button>
        {menu && (
          <div style={{position:"absolute",right:0,top:40,background:C.white,borderRadius:10,boxShadow:"0 4px 20px rgba(0,0,0,0.15)",minWidth:190,zIndex:100}}>
            <div style={{padding:"10px 16px",borderBottom:"1px solid "+C.border}}>
              <p style={{margin:0,fontSize:13,fontWeight:600}}>{user.nombre}</p>
              <p style={{margin:0,fontSize:12,color:C.muted}}>{user.username}</p>
            </div>
            {RC.includes(user.rol) && <div onClick={()=>{setSettings(true);setMenu(false);}} style={{padding:"12px 16px",fontSize:14,cursor:"pointer",borderBottom:"1px solid "+C.border}}>Configuracion</div>}
            <div onClick={()=>{logout();setMenu(false);}} style={{padding:"12px 16px",fontSize:14,cursor:"pointer",color:"#E53E3E"}}>Cerrar sesion</div>
          </div>
        )}
      </div>
    </div>
  );
}
